<template>
  <div class="simple-button" @click.stop="$emit('btnClick', info.info)" :style="{ height: btnHeight }">
    <template v-if="info.info.bindingFunction === 'container-btn'">
      <el-popover class="btn-popover" ref="btnPop" trigger="click" @show="popShow" popper-class="container-btn-pop">
        <template #reference>
          <div>
            <buttonStyle v-bind="$props" />
          </div>
        </template>
        <div class="container-btn-list-l" v-if="isAppenBtnPop">
          <template v-if="info.info.todoList">
            <buttonStyle @click.stop="$emit('btnClick', btn)" v-bind="$props" btnHeight="100%" v-for="btn in info.info.todoList" :key="btn.id" :info="{ info: btn }" @btnClick="$emit('btnClick', $event)" />
          </template>
        </div>
      </el-popover>
    </template>
    <template v-else-if="info.info.bindingFunction === 'qrCode' || info.info.bindingFunction === 'lookQrCode'">
      <el-dropdown @command="onQrcodeCommand">
        <span>
          <buttonStyle :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" />
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-if="info.info.bindingFunction === 'qrCode' && widgetDataObj.qrcodetypes">
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(2)"
                command="minstatic"
                >生成小程序端静态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(3)"
                command="mindynamic"
                >生成小程序端动态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(4)"
                command="h5static"
                >生成H5端静态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(5)"
                command="h5dynamic"
                >生成H5端动态二维码</el-dropdown-item
              >
            </template>
            <!-- 生成查看二维码 -->
            <template v-if="info.info.bindingFunction === 'lookQrCode' && widgetDataObj.lookqrcodetypes">
              <el-dropdown-item command="lookministatic" v-if="widgetDataObj.lookqrcodetypes.includes(1)"
                >生成小程序查看二维码</el-dropdown-item
              >
              <el-dropdown-item command="lookh5static" v-if="widgetDataObj.lookqrcodetypes.includes(2)"
                >生成H5端查看二维码</el-dropdown-item
              >
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
    <template v-else>
      <buttonStyle v-bind="$props" />
    </template>
    <template v-if="isAnnotation">
      <span class="button-annotation-icon">
        <el-tooltip effect="dark" content="提示" placement="top">
          <i class="WSiconfont WSicon-bangzhuzhongxin" @click="openTips"></i>
        </el-tooltip>
      </span>
    </template>
  </div>
</template>

<script>
import buttonStyle from './buttonStyle.vue';
import { dealText } from '@/api/common'
export default {
  // 组件名称
  name: 'simpleButton',
  // 组件参数 接收来自父组件的数据
  props: {
    widgetDataObj: {
      type: Object,
      default:()=>({})
    },
    info: {
      type: Object,
      default: () => ({})
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    // 默认不需要
    size: {
      type: String,
      default:'14px'
    },
    // 默认不需要
    isTable: {
      type: Boolean,
      default: false
    },
    fontStyle: {
      type: Object,
      default: () => ({})
    },
    btnHeight: {
      type: String,
      default: '100%'
    }
  },
  // 局部注册的组件
  components: {
    buttonStyle
  },
  // 组件状态值
  data() {
    return {
      isAppenBtnPop: false,
    }
  },
  // 计算属性
  computed: {
    isAnnotation () {
      return this.info.info.annotationInfo && this.info.info.annotationInfo.isAnnotation
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    popShow() {
      if (this.isAppenBtnPop === false) {
        this.isAppenBtnPop = true
      }
    },
    onQrcodeCommand(value) {
      this.$emit('qrCode-btn',value)
    },
    openTips() {
      const config = this.info.info.annotationInfo || {}
      const name = dealText({
        text: config.formData || '',
        commonData: this.$store.state.userData,
        customData: this.$store.state.doorCustomData,
      })
      config.formData = name
      this.$emit('openTips', config)
    },
  },
}
</script>

<style scoped lang="scss">
.btn-popover {
  height: 30px !important;
  display: inline-block;
}
</style>
